/**
 * Styled Components - Created by cazarez on 14/05/18.
 */
import Icon from 'antd/lib/icon'
import styled from 'styled-components'
import { BLUE, WHITE } from '../../theme/colors'

export const Container = styled.div`
  display: flex;
  flex-flow: column;
  justify-content: center;
  align-items: center;
  font-family: Avenir;
`

export const Title = styled.div`
  font-weight: bold;
  margin-bottom: 10px;
  font-size: 16px;
`

export const Subtitle = styled.div`
  margin-bottom: 6px;
`

export const StoreNameLabel = styled.div`
  margin-top: -4px;
  text-align: center;
  font-weight: bold;
  font-style: italic;
  font-family: Avenir;
  margin-bottom: 20px;
  color: gray;
  background: #f4f4f4;
  width: fit-content;
  padding: 2px 8px;
  border-radius: 5px;
`

export const DownloadButton = styled.div`
  display: flex;
  align-items: center;
  color: white;
  box-shadow: 1px 2px 4px -2px #818181;
  border-radius: 3px;
  padding: 4px 12px;
  font-family: Avenir;
  background: ${BLUE};
  max-width: 190px;
  width: 100%;
  justify-content: center;
  transition: all .25s;
  &:hover {
    cursor: pointer;
    background: ${WHITE};
    color: ${BLUE};
  }
`

export const DownloadIcon = styled(Icon)`
  margin-right: 8px;
`



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--5!./src/components/StoresQR/styledComponents.tsx